import {Observable} from "rxjs/Observable";

export class AbstractService {

    protected handleError(error:any):Observable<any> {
        // In a real world app, we might send the error to remote logging infrastructure
        let errMsg;
        if (error._body) {
            error = error.json();
            if (error.errorCode) {
                errMsg = "errors." + error.errorCode;
            } else {
                errMsg = "errors.-1";
            }

        } else {
            errMsg = "errors.-1";
        }

        console.log(error.message); // log to console instead
        return Observable.throw(errMsg);
    }
}